<script setup lang="ts">
const modalsStore = useModalsStore();
const device = useDevice();

const props = defineProps<{
    title: string,
    desc: string,
    items: Array<{
        title: string,
        icon: string,
        desc: string,
        img: string
    }>,
}>();

function handleOpenModal() {
    modalsStore.openModal('CTA');
};
</script>

<template>
    <SectionsBase id="facilities" class="background">
      <div class="container lg:pl-20!">
        <ChipsDivider>امکانات</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
        <Button
          :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
          pill
          @click="handleOpenModal"
          class="mx-auto relative"
        >
          <IconsCurvedArrow 
            class="absolute text-secondary-600 w-25 top-16 -right-36 scale-y-[-1] origin-top -rotate-45 lg:w-30 
              lg:-right-38 lg:-rotate-35 lg:top-22"
          />
          <span>درخواست مشاوره رایگان</span>
        </Button>
        <ClientOnly>
            <LazySectionsFacilitiesCloudPbxMobile v-if="!device.isDesktop.value" :items="props.items" />
            <LazySectionsFacilitiesCloudPbxDesktop v-else :items="props.items" />
        </ClientOnly>
      </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    bg-gray-50 relative
}
.background::before {
    @apply
    content-[''] absolute top-0 right-0 w-full h-full bg-[url('/img/new/backgrounds/dot-01.webp')] opacity-30
}
</style>